
module.exports = function getResource(label, vars = []) {
    let resources = {
        filterBy: 'Filtrer par'
    };
    return resources[label];
};
